import { VStack, Text } from "native-base";
import styles from "./styles";

const ContentContainer = (props) => (
  <VStack style={styles.content} {...props}>
    <Text testID="txtTitle" variant="md-bold" style={styles.title} pt={styles.title.paddingTop}>
      {props.title ? props.title : ""}
    </Text>
    {props.children}
  </VStack>
);

export default ContentContainer;
